import { isEmpty } from '../../Shared/scriptts/utilities';
import { params, executeSearchUrl, displayResults } from '../search-main';

const countIcon = document.createElement('span');
const isBrandedSearch = document.querySelector<HTMLElement>('#filter-pay')?.dataset.brandedSearch === 'true';
const originalMinGradeOptions: HTMLOptionElement[] = [];
const originalMaxGradeOptions: HTMLOptionElement[] = [];

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector<HTMLInputElement>('#min-pay')?.addEventListener('keyup', minPayKeyup);
    document.querySelector<HTMLButtonElement>('#apply-min-pay')?.addEventListener('click', applyMinPayFilterClicked);
    document.querySelector<HTMLButtonElement>('#apply-grade-range')?.addEventListener('click', applyGradeRangeFilterClicked);
    document.querySelector<HTMLSelectElement>('#min-grade')?.addEventListener('change', minGradeChanged);
    document.querySelector<HTMLSelectElement>('#max-grade')?.addEventListener('change', maxGradeChanged);
    document.querySelector<HTMLButtonElement>(`#clear-filters-pay`)?.addEventListener('click', clearFilterClicked);
});

/**
 * Display pay and pay grade range filter
 */
export function displayPayFilter() {
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyMinPayButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');
    const applyGradeRangeButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (minGradeElem === null || maxGradeElem === null || minPayElem === null || applyMinPayButton === null || applyGradeRangeButton === null || params === undefined) {
        return;
    }

    if (!params.GradeSearch && !isEmpty(params.RemunerationMinimumAmount) && parseInt(params.RemunerationMinimumAmount ?? "0") > 0) {
        syncGradeSelectOptions('-1', '-1');
        minPayElem.value = params.RemunerationMinimumAmount ?? '';
        applyMinPayButton.disabled = false;
        minGradeElem.disabled = true;
        maxGradeElem.disabled = true;
        applyGradeRangeButton.disabled = true;
        if (isBrandedSearch) {
            minPayElem.disabled = true;
            applyMinPayButton.disabled = true;
        }
    }
    else {
        minPayElem.value = '';
        applyMinPayButton.disabled = true;
        minGradeElem.disabled = false;
        maxGradeElem.disabled = false;

        if (params.GradeBucket?.length === 1) {
            syncGradeSelectOptions(params.GradeBucket[0], params.GradeBucket[0]);
            params.GradeSearch = true;
        }
        else if (params.GradeBucket?.length > 1) {
            syncGradeSelectOptions(params.GradeBucket[0], params.GradeBucket[params.GradeBucket.length - 1]);
            params.GradeSearch = true;
        }
        else {
            syncGradeSelectOptions('-1', '-1');
        }

        applyGradeRangeButton.disabled = minGradeElem.selectedIndex < 1 && maxGradeElem.selectedIndex < 1;
    }

    if (isBrandedSearch) {
        minGradeElem.disabled = true;
        maxGradeElem.disabled = true;
        applyGradeRangeButton.disabled = true;
        document.querySelector<HTMLButtonElement>(`#clear-filters-pay`)?.classList.add('hidden');
    }
    else if (params.GradeBucket?.length > 0 || params.RemunerationMinimumAmount) {
        document.querySelector<HTMLButtonElement>(`#clear-filters-pay`)?.classList.remove('hidden');
    }

    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-pay');
    if (titleElem !== null) {
        countIcon.className = params.JobCategoryCode?.length > 0 ? 'bg-warning rounded-full py-1 px-2 ml-2' : 'bg-warning rounded-full py-1 px-2 ml-2 hidden';
        countIcon.innerText = params.JobCategoryCode?.length.toString();
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
        setCountIconDisplay();
    }

    setFilterButtonState();
}

function setCountIconDisplay() {
    if ((params.GradeBucket && params.GradeBucket.length > 0) || (params.RemunerationMinimumAmount !== undefined && params.RemunerationMinimumAmount !== null && params.RemunerationMinimumAmount !== '')) {
        countIcon.innerText = '1';
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }
}

function minPayKeyup(evt: KeyboardEvent) {
    const minPayElem = <HTMLInputElement>(evt.target);
    const applyElem = document.querySelector<HTMLButtonElement>('#apply-min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyGradeRangeButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (minPayElem === null || applyElem === null || minGradeElem === null || maxGradeElem === null || applyGradeRangeButton === null) {
        return;
    }

    let minPay = new Intl.NumberFormat().format(parseFloat(minPayElem.value.replace(/[^0-9.]/g, "")));

    minPayElem.value = isNaN(parseFloat(minPay)) ? '' : minPay;

    if (isBrandedSearch) {
        applyElem.disabled = true;
        minPayElem.disabled = true;
    } else {
        applyElem.disabled = minPayElem.value === '';

        if (minPayElem.value !== '') {
            minGradeElem.disabled = true;
            maxGradeElem.disabled = true;
            applyGradeRangeButton.disabled = true;
            minGradeElem.value = '-1';
            maxGradeElem.value = '-1';
        } else {
            syncGradeSelectOptions('-1', '-1');
            minGradeElem.disabled = false;
            maxGradeElem.disabled = false;
            applyGradeRangeButton.disabled = minGradeElem.selectedIndex < 1 && maxGradeElem.selectedIndex < 1;
        }
    }
}

function minGradeChanged() {
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const applyMinPayButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');

    if (minGradeElem === null || maxGradeElem === null || applyButton === null || minPayElem === null || applyMinPayButton === null) {
        return;
    }

    syncGradeSelectOptions(minGradeElem.value, maxGradeElem.value);

    applyButton.disabled = minGradeElem.selectedIndex < 1 && maxGradeElem.selectedIndex < 1;

    if (minGradeElem.value !== '-1' || maxGradeElem.value !== '-1') {
        minPayElem.disabled = true;
        applyMinPayButton.disabled = true;
    } else {
        minPayElem.disabled = false;
        applyMinPayButton.disabled = minPayElem.value === '';
    }
}

function maxGradeChanged() {
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const applyMinPayButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');

    if (minGradeElem === null || maxGradeElem === null || applyButton === null || minPayElem === null || applyMinPayButton === null) {
        return;
    }

    syncGradeSelectOptions(minGradeElem.value, maxGradeElem.value);

    applyButton.disabled = minGradeElem.selectedIndex < 1 && maxGradeElem.selectedIndex < 1;

    if (minGradeElem.value !== '-1' || maxGradeElem.value !== '-1') {
        minPayElem.disabled = true;
        applyMinPayButton.disabled = true;
    } else {
        minPayElem.disabled = false;
        applyMinPayButton.disabled = minPayElem.value === '';
    }
}

function applyMinPayFilterClicked() {
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const gradeApplyButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (minPayElem === null || isNaN(parseInt(minPayElem.value)) || minGradeElem === null || maxGradeElem === null || gradeApplyButton === null) {
        return;
    }
    params.GradeSearch = false;
    params.GradeBucket = [];
    params.RemunerationMaximumAmount = null;
    params.RemunerationMinimumAmount = minPayElem.value.replace(/[,]/g, '');
    syncGradeSelectOptions('-1', '-1');
    minGradeElem.disabled = true;
    maxGradeElem.disabled = true;
    gradeApplyButton.disabled = true;
    params.Page = '1';

    setCountIconDisplay();
    displayResults(executeSearchUrl, false, true);
    setFilterButtonState();
}

function syncGradeSelectOptions(minGradeValue: string, maxGradeValue: string) {
    cacheGradeOptions();

    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');

    if (!minGradeElem || !maxGradeElem) {
        return;
    }

    setGradeSelectOptions(minGradeElem, originalMinGradeOptions, minGradeValue);
    setGradeSelectOptions(maxGradeElem, originalMaxGradeOptions, maxGradeValue);

    const minGrade = getGradeValue(minGradeElem.value);
    const filteredMaxGradeOptions = originalMaxGradeOptions.filter(option => option.value === '-1' || minGrade === -1 || getGradeValue(option.value) >= minGrade);
    setGradeSelectOptions(maxGradeElem, filteredMaxGradeOptions, maxGradeElem.value);

    const maxGrade = getGradeValue(maxGradeElem.value);
    const filteredMinGradeOptions = originalMinGradeOptions.filter(option => option.value === '-1' || maxGrade === -1 || getGradeValue(option.value) <= maxGrade);
    setGradeSelectOptions(minGradeElem, filteredMinGradeOptions, minGradeElem.value);
}

function cacheGradeOptions() {
    if (originalMinGradeOptions.length > 0 && originalMaxGradeOptions.length > 0) {
        return;
    }

    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');

    if (!minGradeElem || !maxGradeElem) {
        return;
    }

    originalMinGradeOptions.push(...Array.from(minGradeElem.options).map(option => option.cloneNode(true) as HTMLOptionElement));
    originalMaxGradeOptions.push(...Array.from(maxGradeElem.options).map(option => option.cloneNode(true) as HTMLOptionElement));
}

function setGradeSelectOptions(selectElem: HTMLSelectElement, options: HTMLOptionElement[], selectedValue: string) {
    selectElem.replaceChildren(...options.map(option => option.cloneNode(true) as HTMLOptionElement));

    if (options.some(option => option.value === selectedValue)) {
        selectElem.value = selectedValue;
    }
    else {
        selectElem.value = '-1';
    }
}

function getGradeValue(value: string) {
    const gradeValue = parseInt(value);

    return isNaN(gradeValue) ? -1 : gradeValue;
}

function applyGradeRangeFilterClicked() {
    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const minPayApplyButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');

    if (minGradeElem === null || maxGradeElem === null || minPayElem === null || minPayApplyButton === null) {
        return;
    }
    const minGrade = getGradeValue(minGradeElem.value);
    let maxGrade = getGradeValue(maxGradeElem.value);
    const shouldAutoSelectMaxGrade = minGrade > -1 && maxGrade === -1;

    if (shouldAutoSelectMaxGrade) {
        maxGrade = Array.from(maxGradeElem.options)
            .reduce((highestGrade, option) => Math.max(highestGrade, getGradeValue(option.value)), -1);

        if (maxGrade === -1) {
            return;
        }

        maxGradeElem.value = maxGrade.toString();
    }

    if (minGrade > -1 && (maxGrade === -1 || minGrade > maxGrade)) {
        return;
    }

    params.GradeBucket = [];
    params.RemunerationMinimumAmount = null;
    params.RemunerationMaximumAmount = null;
    minPayElem.value = '';
    minPayElem.disabled = false;
    minPayApplyButton.disabled = minPayElem.value === '';
    if (minGrade === -1 && maxGrade === -1) {
        return;
    }
    else if (minGrade === -1) {
        params.GradeBucket = [...Array(maxGrade + 1).keys()].map(i => i.toString());
    }
    else {
        params.GradeBucket = [...Array(maxGrade - (minGrade - 1)).keys()].map(i => (i + minGrade).toString());
    }

    if (minGradeElem.selectedIndex > 0) {
        params.RemunerationMinimumAmount = minGradeElem.options[minGradeElem.selectedIndex].getAttribute('data-salary');
    }
    if (maxGradeElem.selectedIndex > 0) {
        params.RemunerationMaximumAmount = maxGradeElem.options[maxGradeElem.selectedIndex].getAttribute('data-salary');
    }

    params.GradeSearch = true;
    params.Page = '1';
    setCountIconDisplay();
    displayResults(executeSearchUrl, false, true);
    setFilterButtonState();
}

function setFilterButtonState() {
    const defaultButtonText = "Pay or Experience";
    const filterButton = document.querySelector<HTMLButtonElement>(`#filter-button-pay`);
    const filterButtonText = document.querySelector<HTMLElement>(`#filter-button-text-pay`);
    if (!filterButton || !filterButtonText) {
        return;
    }

    const hasFilter = (params.RemunerationMinimumAmount && params.RemunerationMinimumAmount !== '') || params.GradeBucket?.length > 0;

    if (hasFilter) {
        filterButton.classList.add('button-search-filter-applied');
        filterButton.classList.remove('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.add('fill-white');
            icon.classList.remove('fill-gray-darkest');
        });
    }
    else {
        filterButton.classList.remove('button-search-filter-applied');
        filterButton.classList.add('button-search-filter');
        filterButton.querySelectorAll<HTMLElement>('svg').forEach(icon => {
            icon.classList.remove('fill-white');
            icon.classList.add('fill-gray-darkest');
        });
    }

    if (params.GradeSearch === true && params.GradeBucket?.length > 0) {
        const minGradeInput = document.querySelector<HTMLSelectElement>('#min-grade');
        const maxGradeInput = document.querySelector<HTMLSelectElement>('#max-grade');

        if (!minGradeInput || !maxGradeInput) {
            filterButtonText.textContent = defaultButtonText;
            return;
        }

        if (((minGradeInput.value !== '-1' && params.GradeBucket.indexOf('0') === -1) && (maxGradeInput.value !== '-1' && params.GradeBucket.indexOf('16') === -1))
            || (params.GradeBucket.indexOf('0') > -1 && params.GradeBucket.indexOf('16') > -1)) {
            filterButtonText.textContent = `${minGradeInput.options[minGradeInput.selectedIndex].text} to ${maxGradeInput.options[maxGradeInput.selectedIndex].text}`;
        }
        else if (maxGradeInput.value === '-1' || params.GradeBucket.indexOf('16') !== -1) {
            filterButtonText.textContent = `${minGradeInput.options[minGradeInput.selectedIndex].text} and up`;
        }
        else if (minGradeInput.value === '-1' || params.GradeBucket.indexOf('0') !== -1) {
            filterButtonText.textContent = `Up to ${maxGradeInput.options[maxGradeInput.selectedIndex].text}`;
        }
        else {
            filterButtonText.textContent = defaultButtonText;
        }
    }
    else if (params.RemunerationMinimumAmount && params.RemunerationMinimumAmount !== '') {
        filterButtonText.textContent = `Min salary: $${parseInt(params.RemunerationMinimumAmount ?? "0").toLocaleString('en-US')} and up`;
    }
    else {
        filterButtonText.textContent = defaultButtonText;
    }
}

function clearFilterClicked() {
    if (isBrandedSearch) {
        return;
    }

    const minPayElem = document.querySelector<HTMLInputElement>('#min-pay');
    const applyMinPayButton = document.querySelector<HTMLButtonElement>('#apply-min-pay');
    const minGradeElem = document.querySelector<HTMLSelectElement>('#min-grade');
    const maxGradeElem = document.querySelector<HTMLSelectElement>('#max-grade');
    const applyGradeRangeButton = document.querySelector<HTMLButtonElement>('#apply-grade-range');

    if (!minPayElem || !applyMinPayButton || !maxGradeElem || !minGradeElem || !applyGradeRangeButton || !params) {
        return;
    }
    document.querySelector<HTMLButtonElement>(`#clear-filters-pay`)?.classList.add('hidden');

    params.RemunerationMinimumAmount = null;
    params.RemunerationMaximumAmount = null;
    params.GradeBucket = [];

    minPayElem.value = '';
    minPayElem.disabled = false;
    applyMinPayButton.disabled = true;
    syncGradeSelectOptions('-1', '-1');
    minGradeElem.disabled = false;
    maxGradeElem.disabled = false;
    applyGradeRangeButton.disabled = true;

    displayResults(executeSearchUrl, false, true);
}
